// src/features/dashboard/services/Manager/riskTrend.service.ts

import api from '../../../../api/apiService';
import { ENDPOINTS } from '../../../../api/endpoints';

import {
  RiskTrendRequest,
  RiskTrendResponse,
} from '../../types/Manager/atRiskAssociates.types';

// ======================================
// Get Risk Trend
// ======================================

export const getRiskTrend = async (
  request: RiskTrendRequest
): Promise<RiskTrendResponse[]> => {

  const payload: RiskTrendRequest = {
    managerEmployeeCode: request.managerEmployeeCode,
    currentDate: request.currentDate,
    productivityThreshold: request.productivityThreshold,
    noOfDays: request.noOfDays,
    idleThreshold: request.idleThreshold,
    activeHoursThreshold: request.activeHoursThreshold,
    nonProdThreshold: request.nonProdThreshold,
    attendanceThreshold: request.attendanceThreshold,
  };

  console.log('==============================');
  console.log('Risk Trend Request');
  console.log(payload);
  console.log('==============================');

  try {
    const { data } = await api.post<RiskTrendResponse[]>(
      ENDPOINTS.RISK_TREND,
      payload
    );

    return data;
  } catch (error: any) {
    if (error?.response?.status === 404) {
      console.warn('Risk Trend API returned 404. Returning empty array.');
      return [];
    }

    console.error('Risk Trend API Error:', error);
    throw error;
  }
};